
import axios from "axios"

export function getRecallItemList (id) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/recall/${id}/get-recall-items`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};